export default __webpack_public_path__ + "static/media/movie.ce32d9af.png";